import React from "react";
import InfoTip from "../../../../utils/InfoTip";
import { SORT_ROWS } from "../../../../utils/candidatesV2Constants";
import { RESTRICTED_TIP } from "../constants";
import { RefreshIcon } from "../icons";
import SortDropdown, { sortOptionValue } from "./SortDropdown";
import ExportDropdown from "./ExportDropdown";

// Match count, sort indicator, Sort/Refresh/Export actions and active filter chips.
// `cv` is the useCandidatesV2() result.
const CandidatesHeader = ({ cv, isRestricted }) => {
  const {
    searchTerm, pagination, isDisabled, exportLoading,
    sortField, sortDirection, sortOptions, handleSortChange,
    activeFilterChips, handleClearAllFilters, removeChip,
    showExportDropdown, setShowExportDropdown, exportDropdownRef, exportDropdownPortalRef, handleExport,
    triggerFetch,
  } = cv;

  const isCustomSort = sortField !== "created_at" || sortDirection !== "desc";
  const currentSortLabel = sortOptions.length > 0
    ? sortOptions.find((opt) => sortOptionValue(opt) === sortField)?.label
    : SORT_ROWS.find((r) => r.field === sortField)?.label;

  return (
    <div className="candidates-v2-header">
      <div className="candidates-header-top-row">
        <div className="candidates-header-left">
          {(activeFilterChips.length > 0 || searchTerm || isCustomSort) ? (
            <span className="candidates-match-count">
              <strong>{pagination.total || 0}</strong> candidates match your filters
            </span>
          ) : (
            <div />
          )}
          {isRestricted && (
            <span className="assigned-only-note-v2">
              Showing access for candidates assigned to you
              <InfoTip text={RESTRICTED_TIP} />
            </span>
          )}
          {isCustomSort && currentSortLabel && (
            <span className="sort-indicator-v2">
              Sorted by: <strong>{currentSortLabel}</strong>
              <span className="sort-dir-indicator">{sortDirection === "desc" ? "↓" : "↑"}</span>
            </span>
          )}
        </div>

        <div className="candidates-header-actions">
          <SortDropdown
            sortField={sortField}
            sortDirection={sortDirection}
            sortOptions={sortOptions}
            onApply={handleSortChange}
            disabled={isDisabled}
          />
          <button className="header-action-btn-v2" onClick={() => triggerFetch()} disabled={isDisabled} title="Refresh">
            <RefreshIcon />
          </button>
          <ExportDropdown
            open={showExportDropdown}
            setOpen={setShowExportDropdown}
            wrapRef={exportDropdownRef}
            portalRef={exportDropdownPortalRef}
            loading={exportLoading}
            disabled={isDisabled}
            onExport={handleExport}
          />
        </div>
      </div>

      {/* Active filter chips – full width below header row */}
      {activeFilterChips.length > 0 && (
        <div className="active-filters-bar">
          {activeFilterChips.map((chip) => (
            <div key={chip.key} className="filter-chip">
              <span className="filter-chip-cat">{chip.category}:</span>
              <span>{chip.label}</span>
              <button className="chip-remove-btn" onClick={() => activeFilterChips.length === 1 ? handleClearAllFilters() : removeChip(chip.key)} title="Remove filter">×</button>
            </div>
          ))}
          <button className="clear-filters-link" onClick={handleClearAllFilters}>Clear all</button>
        </div>
      )}
    </div>
  );
};

export default CandidatesHeader;
